import { apiInstance, legacyV2Path, legacyV3Path } from '../index'
import { mapArgs } from 'corp-front-vue-commons/src/utils/functions'

const costCenter = {
  get (...args) {
    const params = mapArgs(...args)
    return apiInstance({
      method: 'GET',
      url: `${legacyV2Path()}/costCenter`,
      params
    })
  },

  getById (id) {
    return apiInstance({
      method: 'GET',
      url: `${legacyV3Path()}/costCenter/${id}`
    })
  },

  create (data) {
    return apiInstance({
      method: 'POST',
      url: `${legacyV2Path()}/costCenter`,
      data
    })
  },

  update (id, data) {
    return apiInstance({
      method: 'PUT',
      url: `${legacyV3Path()}/costCenter/${id}`,
      data
    })
  },

  delete (id) {
    return apiInstance({
      method: 'DELETE',
      url: `${legacyV2Path()}/costCenter/${id}`
    })
  },

  addToAllEmployees (id) {
    return apiInstance({
      method: 'PUT',
      url: `${legacyV2Path()}/costCenter/${id}/addToAllEmployees`,
      data: { id }
    })
  },

  export (...args) {
    const params = mapArgs(...args)
    return apiInstance({
      method: 'GET',
      url: `${legacyV2Path()}/costCenter/export`,
      timeout: 60000,
      responseType: 'blob',
      params
    })
  }
}

export default costCenter
